import { render } from "./taskSubmitList.vue?vue&type=template&id=5f093a34&scoped=true"
import script from "./taskSubmitList.vue?vue&type=script&lang=js"
export * from "./taskSubmitList.vue?vue&type=script&lang=js"

import "./taskSubmitList.vue?vue&type=style&index=0&id=5f093a34&lang=scss&scoped=true"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f093a34"]])

export default __exports__